var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.134 1.92c0-.471.382-.853.853-.853h7.517c.27 0 .525.128.686.345l2.51 3.39a.853.853 0 01.167.508v8.77a.853.853 0 01-.853.854H2.987a.853.853 0 01-.853-.854V1.92z",
    fill: "url(#mark_svg__paint0_linear_23017_111477)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.705 4.444a.32.32 0 01.59 0l.9 2.161a.32.32 0 00.27.197l2.333.187a.32.32 0 01.183.562l-1.778 1.523a.32.32 0 00-.103.317l.543 2.277a.32.32 0 01-.478.348l-1.998-1.22a.32.32 0 00-.334 0l-1.998 1.22a.32.32 0 01-.478-.348l.544-2.277a.32.32 0 00-.104-.317L4.02 7.55a.32.32 0 01.183-.562l2.334-.187a.32.32 0 00.27-.197l.899-2.161z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mark_svg__paint0_linear_23017_111477",
    x1: 8,
    y1: 1.067,
    x2: 8,
    y2: 14.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7033"
  })))));
}
export default __webpack_public_path__ + "static/mark.f280970a.svg";
export { SvgMark as ReactComponent };